import {observer} from "mobx-react-lite";
import {useNavigate, useParams} from "react-router-dom";
import * as React from "react";
import {useEffect, useState} from "react";
import {getByContract, generateReport, deleteReport, updateReport} from "../http/reportApi";
import {getContract} from "../http/contractApi";
import {LOGIN_ROUTE, REPORT_ROUTE} from "../utils/constants";
import Box from "@mui/material/Box";
import DeleteIcon from '@mui/icons-material/Delete';
import Button from "@mui/material/Button";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import PeriodChooser from "../components/PeriodChooser";
import {DataGrid} from "@mui/x-data-grid";
import Autocomplete from "@mui/material/Autocomplete";
import {getAll} from "../http/userApi";
import {getTracks as getTrackList} from "../http/trackApi";
import {Context} from "../index";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";


const Reports = observer(()=>{
    let { contract } = useParams();
    const {user} = React.useContext(Context);
    const colLabels = {
        vat: 'Расходы',
        period: 'Период',
        singer: 'Лицензиар',

    };
    const [showForm, setShowForm] = React.useState(false);
    const initForm = {
        vat: 0,
        period: "1/1 - 1/1",
        singersId: 0,
        fiz_ensurance: 30.2,
        fiz_ndfl: 13,
        minusSARValue: 0,
        minusSARValueType: "rub",
        minusSARPunkt: "",
        minusLICValue: 0,
        minusLICValueType: "rub",
        minusLICPunkt: "",
    };
    const [form, setForm] = React.useState(initForm);
    const [tracks, setTracks] = React.useState([]);
    const [reports, setReports] = React.useState([]);
    const [columns, setColumns] = React.useState([]);
    const [editId, setEditId] = React.useState(0);
    const [users, setUsers] = React.useState([]);
    const [filteredUsers, setFilteredUsers] = React.useState([]);
    const [contractInfo, setContractInfo] = React.useState({});
    const navigate = useNavigate();
    const [rows, setRows] = React.useState([]);

    const deleteReportById = async (reportId) => {
        let result = [];

        if (window.confirm("Уверены, что хотите удалить элемент?")) {
            // Code to execute if the user clicks "OK"
            result = await deleteReport(reportId);
        } else {
            // Code to execute if the user clicks "Cancel"
            // console.log("Deletion cancelled.");
        }

    }
    const getData = async (contract)=>{
        let result = [];

        let cols = [];
        result = await getByContract(contract);
        delete result['contract'];
        let tableData = [];
        for (const resultKey in result) {
            const {contract, ...other} = result[resultKey];
            let resultVal = other['result'].length > 0 ? '<span class="success">Готов</span>' : '<span class="">В работе</span>';
            tableData.push({
                ...other,
                "status": resultVal,
                ["vat"]: other.vat + " р",
            });
        }
        if(result.length){
            for (const resultKey in result[0]) {
                if(resultKey === 'status'){
                    cols.push({
                        field: 'status',
                        headerName: 'Статус',
                        width: 100,
                        editable: false,
                        description: 'Статус',
                        sortable: true,
                        renderCell: (item)=>{
                            if(item.row.result.length > 0){
                                return <Button
                                    variant="outlined"
                                    color="success"
                                    size="small"
                                    style={{
                                        cursor: "default"
                                    }}
                                >
                                    Готов
                                </Button>
                            }
                            return <>В работе</>
                        }
                    });
                } else if (resultKey !== 'contract'
                    && resultKey !== 'contractId'
                    && resultKey !== 'createdAt'
                    && resultKey !== 'minusSARValue'
                    && resultKey !== 'minusSARValueType'
                    && resultKey !== 'minusSARPunkt'
                    && resultKey !== 'minusLICValue'
                    && resultKey !== 'minusLICValueType'
                    && resultKey !== 'minusLICPunkt'
                    && resultKey !== 'updatedAt'
                    && resultKey !== 'fiz_ensurance'
                    && resultKey !== 'fiz_ndfl'
                    && resultKey !== 'result'
                    && resultKey !== 'vat'
                ){
                    let width = 200;
                    if(resultKey === 'id'){
                        width = 30;
                    } else if(resultKey === 'singer'){
                        width = 260;
                    }
                    cols.push({
                        field: resultKey,
                        headerName: Object.keys(colLabels).includes(resultKey) ? colLabels[resultKey] : resultKey,
                        width: width,
                        editable: false,
                        description: resultKey,
                        sortable: true,
                    });
                }
            }

            result = tableData;
        }

        cols.push({
            field: 'action',
            headerName: 'Действия',
            sortable: false,
            width: 400,
            renderCell: (params)=>{
                let disabled = params.row.result.length > 0;
                return <>
                    <Button
                        variant="contained"
                        color="info"
                        disabled={disabled}
                        startIcon={<VisibilityIcon />}
                        onClick={(e)=>{
                        e.preventDefault();
                        navigate(REPORT_ROUTE + "/" + params.id);
                    }}>Просмотр</Button>
                    <Button
                        style={{marginLeft: 20}}
                        variant="contained"
                        color="error"
                        onClick={async (e)=>{
                            e.preventDefault();
                            await deleteReportById(params.id);
                        }}
                        startIcon={<DeleteIcon />}
                    >Удалить</Button>
                </>
            }
        });

        setColumns(cols);

        return result;
    }

    const getContractInfo = async (contract) => {
        let result = {};
        result = await getContract(contract);
        return result;
    }

    const rowClick = async ({row, ...tmp}) => {
        let singer = 0;
        let reportInfo = reports.find((report) => report.id === row.id);
        let userInfo = users.find((user) => user.id === reportInfo.singer);
        if(userInfo){
            singer = userInfo;
        }

        if(row.result.length === 0){
            let formData = {
                ...initForm,
                vat: row.vat,
                period: row.period,
                singersId: singer,
                fiz_ensurance: row.ensurance,
                fiz_ndfl: row.ndfl,
                minusSARValue: row.minusSARValue,
                minusSARValueType: row.minusSARValueType,
                minusSARPunkt: row.minusSARPunkt,
                minusLICValue: row.minusLICValue,
                minusLICValueType: row.minusLICValueType,
                minusLICPunkt: row.minusLICPunkt,
            };
            setForm(formData);
            setEditId(row.id);
            setShowForm(true);
        } else {
            navigate(REPORT_ROUTE + "/" + row.id);
        }
    }

    const getUsers = async () => {
        try {
            const parsed = await getAll();
            setUsers([...parsed.filter(item => (item.role === "ARTIST"))]);
            if(parsed.length){
                setForm(prevState => ({...prevState, singersId: parsed[0]}));
            }
            return [...parsed.filter(item => (item.role === "ARTIST"))];
        } catch (error) {
            // if (error.response.status === 401) {
            //     localStorage.clear();
            //     user.setIsAuth(false);
            //     return navigate(LOGIN_ROUTE);
            // }
        }
    };

    const getTracks = async () => {
        try {
            const tracks = await getTrackList();
            setTracks(tracks);
            return tracks;
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }

    };

    useEffect(() => {
        (async ()=>{
            await getUsers();
        })();
    }, []);

    useEffect(() => {
        (async () => {
            await getTracks();
        })();
    }, []);

    useEffect(()=>{
        if(contractInfo.singers && contractInfo.singers.length && users && users.length){
            let singerIds = contractInfo.singers.map(item => item.singersId);
            let filtered = users.filter(item=>singerIds.includes(item.id));
            setFilteredUsers(filtered);
        }
    },[users, contractInfo])

    const formChange = (e, newVal) => {
        console.log(e, newVal);
        if(e.year){
            setForm(prevState => {
                let [from, to] = prevState.period.split(' - ');
                if(e.type === 'from'){
                    from = `${e.year}/${e.quarter}`;
                } else {
                    to = `${e.year}/${e.quarter}`;
                }
                return {
                    ...prevState,
                    'period': `${from} - ${to}`
                }
            });
        } else if(newVal !== undefined) {
            const name = e.currentTarget ? e.currentTarget.getAttribute('name') : e.target.name;
            console.log(e.currentTarget);
            setForm(prevState => ({...prevState, [name]: newVal}));
        } else if(e.target.type === "checkbox") {
            setForm(prevState => ({ ...prevState, [e.target.name]: e.target.checked }));
        } else {
            setForm(prevState => ({...prevState, [e.target.name]: e.target.value}));
        }
    }

    const onSubmit = async (e)=>{
        e.preventDefault();

        if(editId !== 0){
            let result = await updateReport(editId, {
                ...form,
                contractId: contract,
                singersId: form.singersId.id
            });
        } else {
            let result = await generateReport({
                ...form,
                contractId: contract,
                singersId: form.singersId.id
            });
        }

        setForm(initForm);
        setShowForm(false);

        let data = await getData(contract);
        setReports([...data]);
    }

    useEffect(() => {
        (async ()=>{
            let data = await getData(contract);
            setReports([...data]);
        })();
    }, [contract]);

    useEffect(() => {
        (async ()=>{
            let data = await getContractInfo(contract);
            setContractInfo(data);
        })();
    }, [contract]);

    let formattedDate = new Intl.DateTimeFormat('ru-Ru',{year:"numeric", month:"long",day:"2-digit"}).format(new Date()).split(" ").join(" ");
    let formattedCreateDate = new Intl.DateTimeFormat('ru-Ru',{year:"numeric", month:"long",day:"2-digit"}).format(new Date()).split(" ").join(" ");
    let leftDays = 999;
    if(contractInfo?.dateExpire){
        formattedDate = new Intl.DateTimeFormat('ru-Ru',{year:"numeric", month:"long",day:"2-digit"}).format(new Date(contractInfo.dateExpire)).split(" ").join(" ");
        formattedCreateDate = new Intl.DateTimeFormat('ru-Ru',{year:"numeric", month:"long",day:"2-digit"}).format(new Date(contractInfo.createdAt)).split(" ").join(" ");
        let delta = new Date(contractInfo.dateExpire) - new Date();
        leftDays = delta > 0 ? Math.floor(delta/1000/60/60/24) : 0;
    }

    let trackList = [];
    if(contractInfo.tracks){
        for (const trackId of contractInfo.tracks) {
            const track = tracks.find(item=>item.id === trackId);
            if(track){
                trackList.push(`${track.title} - ${track.track}`);
            }
        }
    }
    trackList = trackList.join("<br />");

    const renderInfo = ()=>{
        let result = [];

        if(users.length > 0){
            for (const reportsKey in reports) {
                let reportItem = reports[reportsKey];
                let singers = users.filter(item=>item.id === reportItem.singer);
                if(singers && singers.length > 0) {
                    result.push({
                        ...reportItem,
                        singer: `${singers[0].name}`
                    });
                }
            }

            return result;
        }

        return reports
    }

    const renderFiz = ()=>{

        return (
            <>
                <Box
                    width={"100%"}
                    p={2}
                    display="flex"
                    alignItems="center"
                    gap={4}
                    justifyContent="space-between"
                >
                    <TextField
                        className="login__page__item"
                        label="Иные платежи в бюджет (%)"
                        name={'fiz_ensurance'}
                        type={"number"}
                        step={0.1}
                        variant="outlined"
                        color="secondary"
                        value={form['fiz_ensurance']}
                        sx={{"flex": "1 1 100%"}}
                        onChange={formChange}
                    />
                </Box>
                <Box
                    width={"100%"}
                    p={2}
                    display="flex"
                    alignItems="center"
                    gap={4}
                    justifyContent="space-between"
                >
                    <TextField
                        className="login__page__item"
                        label="НДФЛ (%)"
                        name={'fiz_ndfl'}
                        type={"number"}
                        step={0.1}
                        variant="outlined"
                        color="secondary"
                        value={form['fiz_ndfl']}
                        sx={{"flex": "1 1 100%"}}
                        onChange={formChange}
                    />
                </Box>
            </>
        )
    }

    const rowsList = renderInfo();

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                justifyContent="flex-end"
                width={'100%'}
                p={2}
            >
                <Button
                    color="secondary"
                    variant="outlined"
                    onClick={()=>{
                        setEditId(0);
                        setShowForm(true);
                    }}
                >Создать отчет</Button>
            </Box>
            <Dialog
                open={showForm}
                onClose={()=>{
                    setShowForm(false);
                    setEditId(0);
                    setForm(initForm);
                }}
                width={800}
                my={4}
                gap={4}
                p={2}
                sx={{ border: "2px solid grey" }}
            >
                <Box
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="stretch"
                    flexDirection="column"
                >
                    <Box
                        p={2}
                    >
                        <Typography variant="h4" gutterBottom>
                            {editId ? "Редактирование отчета" : "Создание отчета"}
                        </Typography>
                    </Box>
                    <Box
                        width={"100%"}
                        display="flex"
                        alignItems="center"
                        justifyContent="flex-start"
                        p={2}
                    >
                        <Typography >
                            Параметры расчета
                        </Typography>
                    </Box>
                    {contractInfo.opf === "fiz" ? renderFiz() : null}
                    <Box
                        width={"100%"}
                        display="flex"
                        alignItems="center"
                        justifyContent="flex-start"
                        p={2}
                    >
                        <Typography >
                            Вычет из доли САР
                        </Typography>
                    </Box>
                    <Box
                        width={"100%"}
                        p={2}
                        display="flex"
                        alignItems="center"
                        gap={4}
                        justifyContent="space-between"
                    >
                        <TextField
                            className="login__page__item"
                            label="Пункт договора"
                            name={'minusSARPunkt'}
                            variant="outlined"
                            color="secondary"
                            value={form['minusSARPunkt']}
                            sx={{"flex": "1 1 100%"}}
                            onChange={formChange}
                        />
                        <TextField
                            className="login__page__item"
                            label="Вычет из доли САР"
                            name={'minusSARValue'}
                            type={"number"}
                            variant="outlined"
                            color="secondary"
                            value={form['minusSARValue']}
                            sx={{"flex": "1 1 100%"}}
                            onChange={formChange}
                        />
                        <ToggleButtonGroup
                            value={form['minusSARValueType']}
                            name={'minusSARValueType'}
                            exclusive
                            onChange={formChange}
                        >
                            <ToggleButton value="rub">Руб</ToggleButton>
                            <ToggleButton value="perc">%</ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                    <Box
                        width={"100%"}
                        display="flex"
                        alignItems="center"
                        justifyContent="flex-start"
                        p={2}
                    >
                        <Typography >
                            Вычет из доли Лицензиара
                        </Typography>
                    </Box>
                    <Box
                        width={"100%"}
                        p={2}
                        display="flex"
                        alignItems="center"
                        gap={4}
                        justifyContent="space-between"
                    >
                        <TextField
                            className="login__page__item"
                            label="Пункт договора"
                            name={'minusLICPunkt'}
                            variant="outlined"
                            color="secondary"
                            value={form['minusLICPunkt']}
                            sx={{"flex": "1 1 100%"}}
                            onChange={formChange}
                        />
                        <TextField
                            className="login__page__item"
                            label="Вычет из доли САР"
                            name={'minusLICValue'}
                            type={"number"}
                            variant="outlined"
                            color="secondary"
                            value={form['minusLICValue']}
                            sx={{"flex": "1 1 100%"}}
                            onChange={formChange}
                        />
                        <ToggleButtonGroup
                            value={form['minusLICValueType']}
                            name={'minusLICValueType'}
                            exclusive
                            onChange={formChange}
                        >
                            <ToggleButton value="rub">Руб</ToggleButton>
                            <ToggleButton value="perc">%</ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                    <Box
                        p={2}
                        display="flex"
                        alignItems="stretch"
                        gap={4}
                        justifyContent="space-between"
                        flexDirection="column"
                    >
                        <Typography>
                            Лицензиар
                        </Typography>
                        <Autocomplete
                            width={"100%"}
                            disablePortal
                            // freeSolo
                            noOptionsText={"Нет доступных лицензиаров в списке"}
                            id="combo-box-demo"
                            options={filteredUsers}
                            onChange={(event, newValue) => {
                                if(newValue){
                                    formChange({
                                        target: {
                                            value: newValue,
                                            name: "singersId"
                                        }
                                    });
                                }
                            }}
                            renderInput={(params, ref) => <TextField
                                {...params}
                                color="secondary"
                                name={"singersId"}
                                ref={ref}
                                inputProps={{
                                    ...params.inputProps, // HERE
                                    maxLength: 255
                                }}
                            />}
                            getOptionLabel={(option) => {
                                for (const userListKey in users) {
                                    if(users[userListKey]['id'] === option.id){
                                        return users[userListKey]['name'];
                                    }
                                }
                                return users[option] ? users[option].name : ""
                            }}
                            value={form["singersId"]}
                            isOptionEqualToValue={(option, value)=> {
                                return form["singersId"] === value
                            }}
                        />
                        {/*<TextField*/}
                        {/*    className="login__page__item"*/}
                        {/*    label="vat"*/}
                        {/*    name={'vat'}*/}
                        {/*    type={"number"}*/}
                        {/*    variant="outlined"*/}
                        {/*    color="secondary"*/}
                        {/*    value={form['vat']}*/}
                        {/*    sx={{"flex": "1 1 100%"}}*/}
                        {/*    onChange={formChange}*/}
                        {/*/>*/}
                    </Box>
                    <Box
                        width={"100%"}
                        p={2}
                        display="flex"
                        alignItems="center"
                        gap={4}
                        justifyContent="space-between"
                        flexWrap="wrap"
                    >
                        <Box
                            width={"100%"}
                            display="flex"
                            alignItems="center"
                            justifyContent="flex-start"
                        >
                            <Typography >
                                Срок отчета
                            </Typography>
                        </Box>
                        <PeriodChooser
                             setPeriod={formChange}
                             type={'from'}
                             period={form['period']}
                        />
                        <PeriodChooser
                             setPeriod={formChange}
                             type={'to'}
                             period={form['period']}
                        />
                    </Box>
                    <Box
                        p={2}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={4}
                    >
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={()=>{
                                setForm(initForm);
                                setEditId(0);
                                setShowForm(false);
                            }}
                        >
                            Отмена
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={onSubmit}
                        >
                            {editId ? "Обновить отчет" : "Добавить отчет"}

                        </Button>
                    </Box>
                </Box>
            </Dialog>
            <Box
                width={'100%'}
                p={2}
            >
                <Box
                    p={2}
                >
                    <Typography variant={'h4'}>Договор <u><b>{contractInfo.name}</b></u></Typography>
                </Box>
                <Box
                    p={2}
                >
                    <table>
                        <tbody>
                            <tr>
                                <td valign={'top'}>Треки (версии названий):</td>
                                <td dangerouslySetInnerHTML={{__html: trackList}}></td>
                            </tr>
                            <tr>
                                <td>Создан:</td>
                                <td><b>{formattedCreateDate}</b></td>
                            </tr>
                            <tr>
                                <td>Срок заверщения:</td>
                                <td><b>{formattedDate} ({leftDays} дней)</b></td>
                            </tr>
                            {contractInfo.description ? <tr><td>Комментарий:</td><td>{contractInfo.description}</td></tr> : ""}
                        </tbody>
                    </table>

                </Box>
                <Box
                    p={2}
                >
                    <Typography variant={'h5'}>Отчеты</Typography>
                    {reports && columns && (
                        <Box sx={{ height: "100%", width: "100%" }}>
                            <DataGrid
                                rows={rowsList}
                                columns={columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 100,
                                        },
                                    },
                                }}
                                pageSizeOptions={[10, 20, 50, 100]}
                                disableRowSelectionOnClick
                                onRowClick={rowClick}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        </div>
    )
});

export default Reports;